import { Diamond } from "@dreamhub/designsystem/icons";
import PageLayout from "@/pages/settings/components/PageLayout";
import { GeneralTab } from "@/pages/settings/components/dealsSettings/GeneralTab";
import { FieldManagementTab } from "@/pages/settings/components/dealsSettings/FieldManagement/FieldManagementTab";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DealsSettingsTabs } from "@/pages/settings/types";
import StageStudioTab from "@/pages/settings/components/dealsSettings/StageStudio/StageStudioTab";
import { useSearchParams } from "react-router-dom";

const TRANSLATION_KEY = "settings.deals";
const TRANSLATION_KEY_TABS = "settings.deals.tabs";

export const DealsSettings = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabValue, setTabValue] = useState<DealsSettingsTabs>(() => {
    const tabParam = searchParams.get("tab");
    return Object.values(DealsSettingsTabs).includes(
      tabParam as DealsSettingsTabs
    )
      ? (tabParam as DealsSettingsTabs)
      : DealsSettingsTabs.GENERAL;
  });

  useEffect(() => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabValue);
      return params;
    });
  }, [tabValue, setSearchParams]);

  const getTabOptions = () => {
    const options: Record<string, string> = {};
    Object.values(DealsSettingsTabs).forEach((tab) => {
      options[tab] = t(`${TRANSLATION_KEY_TABS}.${tab}`);
    });

    return options;
  };

  const onTabChange = (newTabValue: string) => {
    setTabValue(newTabValue as DealsSettingsTabs);
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case DealsSettingsTabs.GENERAL:
        return <GeneralTab />;
      case DealsSettingsTabs.FIELD_MANAGEMENT:
        return <FieldManagementTab />;
      case DealsSettingsTabs.STAGE_STUDIO:
        return <StageStudioTab />;
      default:
        return <GeneralTab />;
    }
  };

  return (
    <PageLayout
      data-test="settings-deals-page"
      title={t(`${TRANSLATION_KEY}.title`)}
      logoIcon={<Diamond />}
      tabs={{
        options: getTabOptions(),
        defaultValue: tabValue,
        valueSelected: onTabChange
      }}
    >
      {renderTabContent()}
    </PageLayout>
  );
};
